import "./DeployContinuous.css";
import img from "../deployassets/deploycontinuous.png";

export default function DeployContinuous() {
  const counters = [
    {
      percentage: "41%",
      description: "Traditional Ops is 41% more time-consuming overall",
      bg: "#E7F3FF",
    },
    {
      percentage: "21%",
      description: "Faster deployment cycles with automated CD pipelines",
      bg: "#F7EBFF",
    },
    {
      percentage: "7h",
      description: "Reduction in deployment failures with continuous testing",
      bg: "#FFF4E6",
    },
  ];

  return (
    <div id="deploy-continuous" className="outsourcemainclass">
      <div className="top">
        <div className="left">
          <img src={img} alt="error" />
        </div>
        <div className="right">
          <h2 className="heading">What Is Continuous Delivery & Deployment?</h2>
          <p className="subheading">
            Continuous Delivery (CD) is a DevOps practice where every code
            change is automatically prepared for release, ensuring it's
            deployable at any time. Continuous Deployment, a step beyond,
            automates the release of every change directly into production,
            reducing release cycles and enhancing user experience. Together, CD
            practices empower teams to release faster, safer, and more reliably.
          </p>
        </div>
      </div>

      <div className="counters">
        <div className="counter-left">
          <div className="counter">
            <h1>40%</h1>
          <p>Traditional Ops is 41% more time-consuming overall</p>
          </div>
        </div>
        <div className="counter-right">
          {counters.map((counter, index) => (
            <div
              className="counter"
              key={index}
              style={{ backgroundColor: counter.bg }}
            >
              <h1>{counter.percentage}</h1>
              <p>{counter.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
